import type { BulkCsvOrderRow } from '#features/csvImport/model/CsvOrderRow.ts';

export const mapBulkRawRow = (columns: string[]): BulkCsvOrderRow => ({
    order_number: columns[0]?.trim() ?? '',
    customer_name: columns[1]?.trim() ?? '',
    pickup_company: columns[2]?.trim() ?? '',
    pickup_street: columns[3]?.trim() ?? '',
    pickup_housenumber: columns[4]?.trim() ?? '',
    pickup_country: columns[5]?.trim() ?? '',
    pickup_zip: columns[6]?.trim() ?? '',
    pickup_city: columns[7]?.trim() ?? '',
    pickup_from_date: columns[8]?.trim() ?? '',
    pickup_from_time: columns[9]?.trim() ?? '',
    pickup_to_date: columns[10]?.trim() ?? '',
    pickup_to_time: columns[11]?.trim() ?? '',
    pickup_coordinates: columns[12]?.trim() ?? '',
    pickup_comment: columns[13]?.trim() ?? '',
    delivery_company: columns[14]?.trim() ?? '',
    delivery_street: columns[15]?.trim() ?? '',
    delivery_housenumber: columns[16]?.trim() ?? '',
    delivery_country: columns[17]?.trim() ?? '',
    delivery_zip: columns[18]?.trim() ?? '',
    delivery_city: columns[19]?.trim() ?? '',
    delivery_from_date: columns[20]?.trim() ?? '',
    delivery_from_time: columns[21]?.trim() ?? '',
    delivery_to_date: columns[22]?.trim() ?? '',
    delivery_to_time: columns[23]?.trim() ?? '',
    delivery_coordinates: columns[24]?.trim() ?? '',
    delivery_comment: columns[25]?.trim() ?? '',
    bulk_quantity: columns[26]?.trim() ?? '',
    bulk_quantity_unit: columns[27]?.trim() ?? '',
    bulk_name: columns[28]?.trim() ?? '',
});
